import React from 'react'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import s from './AboutContactBlock.module.scss'

export type AboutContactBlockProps = {}

export const AboutContactBlock: React.FC<AboutContactBlockProps> = () => {
  return (
    <ContentSection className="container">
      <Typography
        variant={EnumTypographyVariants.H2}
        text="Contact us"
        className={s.AboutContactBlock__title}
      />

      <div className={s.AboutContactBlock__contacts}>
        <div className={s.AboutContactBlock__contactBlock}>
          <Typography
            variant={EnumTypographyVariants.H4}
            text="INSQUAD INC"
            className={s.AboutContactBlock__subtitle}
          />
          <Typography
            variant={EnumTypographyVariants.H7}
            text="256 CHAPMAN ROAD STE 105-4, NEWARK"
          />
        </div>

        <div className={s.AboutContactBlock__contactBlock}>
          <Typography
            variant={EnumTypographyVariants.H4}
            text="E-MAIL"
            className={s.AboutContactBlock__subtitle}
          />
          <Typography
            variant={EnumTypographyVariants.H7}
            as="a"
            href="mailto:partners@insquad.com"
            text="partners@insquad.com"
          />
        </div>
      </div>
    </ContentSection>
  )
}
